import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ToastContainer />
    <App />
  </Provider>
);
